import {Component, OnChanges, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {ReplaySubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../../shared/services/form-helper.service';
import {COMPANY_ASF,
  COMPANY_ASF_PREMIUM,
  CONTRACT_TYPE_MANDATE,
  DictService,
} from '../../../../shared/services/dict.service';
import {first, map, takeUntil} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {InvoiceService} from '../../../../shared/services/invoice.service';
import moment from 'moment/moment';
import {FileBase64} from '../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component';
import {CommissionSettlement} from "../../../../shared/interface/commission-settlement";
import {CommissionSettlementService} from "../../../../shared/services/commission-settlement.service";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {Contract} from "../../../../shared/interface/contract";
import {validIban} from "../../../../shared/validator/iban-validator";
import {Partner} from "../../../../shared/interface/partner";
import {AddInitialBalanceComponent} from "../add-initial-balance/add-initial-balance.component";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {ContractService} from "../../../../shared/services/contract.service";
import {Invoice} from "../../../../shared/interface/invoice";
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'app-add-invoice',
  templateUrl: './add-invoice.component.html',
  styleUrls: ['./add-invoice.component.scss']
})
export class AddInvoiceComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  readonly CONTRACT_TYPE_MANDATE = CONTRACT_TYPE_MANDATE;
  selectedPartner?: Partner = null;
  blockSubmit = false;
  invoiceForm: FormGroup;
  billingMonthControl: FormControl;
  selectedBillingMonth: FormControl;
  numberControl: FormControl;
  grossControl: FormControl;
  balanceControl: FormControl;
  issueDateControl: FormControl;
  contractControl: FormControl;
  fileContentControl: FormControl;
  fileNameControl: FormControl;
  vatInvoiceControl: FormControl;
  checkoutMethodControl: FormControl;
  noteControl: FormControl;
  requiredParentContract = true;
  accountNumber: FormControl;
  fileMaxSize = 5242880;
  processingRequest = false;
  errors: any = {};
  contractBalanceToPayNet?: number;
  contractBalanceInitialBalanceNet?: number;
  contractBalanceSwap?: number;
  debitNet?: number;
  contractBalanceTotalCommission?: number;
  contractBalanceContract?: string;
  contractBalancePaid?: number;
  partner?: Partner;
  selectedInsuranceCompany: InsuranceCompany;
  settlements: CommissionSettlement[] = [];
  settlementsUuid:  CommissionSettlement[] = [];
  selfBillingAccountNumberControl: FormControl;
  settlementsSubject: ReplaySubject<CountedAndPaginated<CommissionSettlement>>
    = new ReplaySubject(1);
   settlementsSubjectSecond: ReplaySubject<CountedAndPaginated<CommissionSettlement>>
    = new ReplaySubject(1);
  commissionSettlement: any;
  addInitialBalanceButton = true;
  checkInvoice = false;
  disabledInvoice = false;
  dataInvoiceSource: MatTableDataSource<Invoice> = new MatTableDataSource<Invoice>();
  displayedColumns: string[] = ['number', 'net', 'download', 'issueDate', 'status'];
  selectedContract?: Contract = null;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private invoiceService: InvoiceService,
    private commissionSettlementService: CommissionSettlementService,
    private contractService: ContractService

  ) {
    const date = moment();
    date.subtract(1, 'month');

    this.invoiceForm = this.fb.group({
      billingMonth: this.billingMonthControl = fb.control(''),
      // selectedBillingMonth: this.selectedBillingMonth = fb.control('', [Validators.required]),
      number: this.numberControl = fb.control('', [Validators.required]),
      gross: this.grossControl = fb.control('', [Validators.required]),
      initialBalance: this.balanceControl = fb.control('', ),
      issueDate: this.issueDateControl = fb.control('', [Validators.required]),
      contract: this.contractControl = fb.control('', [Validators.required]),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      fileName: this.fileNameControl = fb.control(''),
      vatInvoice: this.vatInvoiceControl = fb.control(false),
      checkoutMethod: this.checkoutMethodControl = fb.control(false),
      accountNumber: this.accountNumber = fb.control('', [Validators.required, validIban()]),
      note: this.noteControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    const activeToDate = new Date();
    activeToDate.setMonth(activeToDate.getMonth() - 1);
    this.billingMonthControl.setValue(activeToDate);
    this.invoiceForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        // this.billingMonthControl.setErrors(null);
      });

    this.settlementsSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        // this.settlements = response.items;
        this.commissionSettlement = response.items;
      });
    this.settlementsSubjectSecond
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        this.settlements = response.items;
        this.settlements.forEach((settlementsResponse) => {
          settlementsResponse.contractSettlements.forEach((contracSettlementsResponse) => {
            contracSettlementsResponse.invoices.sort((a, b) =>
              new Date(a.invoice.createdAt).getTime() - new Date(b.invoice.createdAt).getTime());
          });
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
    contractChanged(contract: Contract): void {
    this.addInitialBalanceButton = false;
    const filters: any = {
      onlyNew: 1,
      contract: contract?.uuid,
    };
    this.commissionSettlementService.loadList(
      0,
      10,
      filters,
      this.settlementsSubject
    );

    if (contract?.partner){
      this.accountNumber.setValue(contract?.partner?.accountNumber);
    } else {
      this.accountNumber.setValue(contract?.ofwca?.accountNumber);
    }
    this.partner = contract?.partner;
    this.contractBalanceToPayNet = contract.contractBalance?.toPayNet;
    this.contractBalanceInitialBalanceNet = contract.contractBalance?.initialBalanceNet;
    this.contractBalanceTotalCommission = contract.contractBalance?.totalCommission;
    this.contractBalancePaid = contract.contractBalance?.paid;
    this.contractBalanceSwap = contract.contractBalance?.swap;
    this.debitNet = contract.contractBalance?.debitNet;
    this.contractBalanceContract = contract.uuid;
    this.selectedContract = contract;
    this.selectedPartner = contract.partner;
    this.blockSubmit = (this.selectedPartner.invoiceAddBlockPremium && this.selectedContract.company.key === COMPANY_ASF_PREMIUM)
        || (this.selectedPartner.invoiceAddBlockAsf && this.selectedContract.company.key === COMPANY_ASF);
  }
  contractChangedSecond(contract: Contract): void {
    const filters: any = {
      contract: contract?.uuid,
    };
    this.commissionSettlementService.loadList(
      0,
      10,
      filters,
      this.settlementsSubjectSecond
    );
  }

  save(): void {
    this.disabledInvoice = true;
    this.invoiceService.checkInvoice(this.contractControl.value, this.numberControl.value, this.grossControl.value )
      .pipe(first())
      .subscribe((invoices) => {
        this.dataInvoiceSource.data = invoices;
        this.processingRequest = false;
        this.checkInvoice = true;
        invoices.every((invoice: Invoice) => {
          if (invoice.number === this.numberControl.value) {
            this.numberControl.setErrors({checkInvoiceNumber: true});
            this.checkInvoice = false;
          }
        });
        if (this.checkInvoice) {
          this.processingRequest = true;
          this.invoiceService.sendForm(
            this.invoiceForm.value,
          )
            .pipe(
              first()
            )
            .subscribe((response: Uuid) => {
              this.snackBar.open('Pomyślnie utworzono fakturę', '', {
                duration: 2000,
              });
              this.processingRequest = false;
              this.router.navigate(['/faktury/szczegoly', response.uuid]);
            }, (error: HttpErrorResponse) => {
              this.disabledInvoice = false;
              this.processingRequest = false;

              this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
                duration: 2000,
              });

              if (error.status === 400) {
                this.errors = error.error.error.list;
                this.formHelper.setBackendErrorState(this.invoiceForm, this.errors);
              }
            });
        }
      });

  }

  cancel(): void {
    this.router.navigate(['/faktury']);
  }

  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }
  ngOnChanges(): void {
  }
  addInitialBalance(): void{
    const dialogRef = this.dialog.open(AddInitialBalanceComponent, {
      width: '50vw',
      maxHeight: '90vh',
      data: {contract: this.contractBalanceContract}
    });
    dialogRef.afterClosed().subscribe( result => {
      if (result) {
        this.grossControl.reset();
        // this.addInitialBalanceButton = false;
        this.loadContractBalance();
      }
    });
  }
  loadContractBalance(): void {
    this.contractService.get(this.contractBalanceContract)
      .pipe()
      .subscribe((contract: Contract) => {
        this.contractBalanceToPayNet = contract.contractBalance?.toPayNet;
        this.contractBalanceInitialBalanceNet = contract.contractBalance?.initialBalanceNet;
        this.contractBalanceSwap = contract.contractBalance?.swap;
        this.contractBalanceTotalCommission = contract.contractBalance?.totalCommission;
        this.contractBalancePaid = contract.contractBalance?.paid;
      });
  }

  check(): void
  {
    this.disabledInvoice = false;
    this.processingRequest = true;
    this.invoiceService.checkInvoice(this.contractControl.value, this.numberControl.value, this.grossControl.value )
      .pipe(first())
      .subscribe((invoices) => {
        this.dataInvoiceSource.data = invoices;
        this.processingRequest = false;
        this.checkInvoice = true;
        invoices.every((invoice: Invoice) => {
          if (invoice.number === this.numberControl.value) {
            this.numberControl.setErrors({checkInvoiceNumber: true});
            this.checkInvoice = false;
          }
        });
      });
  }
  downloadPdf(invoice): void {
    this.invoiceService.downloadPdf(invoice.id);
  }

  isAnyPropertySet(): boolean {
    return this.partner && (
      this.partner.dateOfSuspension !== null ||
      this.partner.resumptionDate !== null ||
      this.partner.endDate !== null ||
      this.partner.deletionRegonData !== null ||
      this.partner.judgmentDeclaringDate !== null ||
      this.partner.completionBankruptcyProceedingDate !== null ||
      this.partner.deletionRegistryData !== null
    );
  }
}
